import { render, staticRenderFns } from "./PatientHistoryViewDetailsDocuments.vue?vue&type=template&id=06825e06&scoped=true&lang=pug&"
import script from "./PatientHistoryViewDetailsDocuments.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryViewDetailsDocuments.vue?vue&type=script&lang=js&"
import style0 from "./PatientHistoryViewDetailsDocuments.vue?vue&type=style&index=0&id=06825e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06825e06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
